import H from 'history'
import { BreachWallContentType } from './BreachWallTypes'

export interface BreachWallDisplayValues {
    // Used for analytics, should be a more human readable version of `type`
    deal: string
    // The breach type, must match the Feature Toggle value as well as the Offers API variant name
    type: BreachWallContentType
}

// 'canShowXXBreach' is created to include topics and subpages, whereas 'otherOptions.canShowXX' is a site wide breach screen
export function getBreachWallOptions(
    /** Used to determine if a given breach should be shown based on the topic */
    location: H.Location,
    breachType: BreachWallContentType,
): BreachWallDisplayValues {
    // Fallback for when a breachType has a case but the conditions are not met.
    const DEFAULT_TYPE: BreachWallDisplayValues = {
        deal: '',
        type: 'default',
    }

    /** Only add a case to this if you need specific conditions other than the toggle being enabled.
     * i.e. `afl-footy-lives-here-breach-screen` needs both the toggle to be on and the topic to be sports.
     * All other cases fall through to the default which returns the provided `breachType` as the `type`
     */
    switch (breachType) {
        case 'afl-footy-lives-here-breach-screen':
            if (doesStartWithTopic(location, 'sport')) {
                return {
                    deal: getBreachDeal(breachType),
                    type: breachType,
                }
            }
            return DEFAULT_TYPE
        default: {
            return {
                deal: getBreachDeal(breachType),
                type: breachType,
            }
        }
    }
}

/** Returns a version of the breach deal better suited for use in analytics.
 * eg given `afl-footy-lives-here-breach-screen`, will return AflFootyLivesHereBreachScreen`
 */
function getBreachDeal(breachType: BreachWallContentType) {
    return breachType
        .split('-')
        .map((char) => `${char.charAt(0).toUpperCase()}${char.substring(1)}`)
        .join('')
}

// topic checkers
function doesStartWithTopic(location: H.Location, topic: string): boolean {
    const pathName = location.pathname
    return pathName.startsWith('/' + topic)
}
